export const IMAGES = {
  logo: "/sybils-logo.png",
  chronos:
    "https://static.prod-images.emergentagent.com/jobs/6191983f-92f1-4de9-9adc-9e0de9357616/images/c262ffc8e87dcbc2e113828ebe2fa08200dc0b138a65f6017d300b3b522d6558.jpeg",
  oracleDeck:
    "https://static.prod-images.emergentagent.com/jobs/6191983f-92f1-4de9-9adc-9e0de9357616/images/14859b72b5b4616b5b561baa27197ee80460d7edf1457652eaa3bff6c8c45cfd.jpeg",
  apothecary:
    "https://static.prod-images.emergentagent.com/jobs/6191983f-92f1-4de9-9adc-9e0de9357616/images/41f355a14276db78a6dbfa85c1ac3333ac764af4ba7e74dc592f3d48f06ce686.jpeg",
  ruler:
    "https://images.unsplash.com/photo-1773594030129-b311b88464c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxpbmRpZ2Vub3VzJTIwZGFyayUyMHNraW4lMjBiZWF1dGlmdWwlMjB0cmliYWwlMjB3b21hbiUyMHBvcnRyYWl0JTIwaGlnaCUyMGZhc2hpb24lMjBldGhlcmVhbHxlbnwwfHx8fDE3ODQ5NzUwNTZ8MA&ixlib=rb-4.1.0&q=85",
  creator:
    "https://images.pexels.com/photos/1432238/pexels-photo-1432238.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "The end of linear time",
    body: "The old world measured worth in speed — a straight line drawn toward a horizon that kept receding. We were taught to hustle against our own nature. Sybils decline the race.",
  },
  {
    n: "02",
    title: "The return to the cycle",
    body: "Power that lasts moves in seasons: rest, gather, rise, release. The matriarch reads the moon, not the stopwatch. She builds in rhythm with the body, the earth, and the lineage.",
  },
  {
    n: "03",
    title: "Authority as stewardship",
    body: "To lead is not to dominate but to tend. We pool capital, wisdom, and grief. What we protect today becomes the inheritance of women not yet born.",
  },
];

export const PILLARS = [
  {
    id: "vault",
    tag: "Physical Goods",
    title: "The Matriarch's Vault",
    body: "Objects of ritual and remembrance — a cyclical journal, an oracle deck of matriarchs, and grounding apothecary crafted for high-stakes decisions.",
    image: "oracleDeck",
    span: "lg:col-span-7",
  },
  {
    id: "council",
    tag: "Membership Mastermind",
    title: "The Sybils Council",
    body: "A global circle of founders, executives, and matriarchs. Peer advisory over cutthroat networking — capital pooling and ancestral business planning.",
    image: "ruler",
    span: "lg:col-span-5",
  },
  {
    id: "academies",
    tag: "Immersive Retreats",
    title: "The Matriarchal Academies",
    body: "Retreats in wealth stewardship, intergenerational asset transfer, somatic leadership, and energetic sovereignty.",
    image: "creator",
    span: "lg:col-span-12",
  },
];

export const PRODUCTS = [
  {
    id: "chronos",
    title: "The Chronos Journal",
    sub: "13-Moon Cyclical Planner",
    body: "Track energy, intuition, and ancestral patterns instead of rigid linear time.",
    image: "chronos",
  },
  {
    id: "decks",
    title: "Oracle & Governance Decks",
    sub: "A 78-Card Archetype System",
    body: "Traditional tarot merged with historical matriarchs and strategic governance.",
    image: "oracleDeck",
  },
  {
    id: "apothecary",
    title: "Apothecary & Fragrance",
    sub: "Vetiver · Frankincense · Blue Lotus",
    body: "Grounding roots and opening notes to center leaders before high-stakes decisions.",
    image: "apothecary",
  },
];
